import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Text, { Title } from '../../../../packages/kiti/components/presentation/Text'
import Line from '../../../../packages/kiti/components/helpers/Line'

const ModalHeader = () => {
  const { t } = useTranslation('editServiceOrderAutomaticDistribution')

  return (
    <>
      <Title size="h4" color={COLORS.dark2} noMargin>
        {t('title')}
      </Title>
      <Text>{t('description')}</Text>
      <Separator weight={4} />
      <Line />
      <Separator weight={2} />
    </>
  )
}

export default ModalHeader
